/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock volume (V1)`)
};

const es_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen inicial (V1)`)
};

const de_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stammvolumen (V1)`)
};

const nl_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockvolume (V1)`)
};

const fr_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume mère (V1)`)
};

const it_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume madre (V1)`)
};

const pt_br2_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume do estoque (V1)`)
};

const pt_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume da solução-mãe (V1)`)
};

const ja_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストック体積 (V1)`)
};

const zh_soldil_field_v1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`母液体积（V1）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_field_v1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_field_v1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_field_v1", locale)
	if (locale === "en") return en_soldil_field_v1(inputs)
	if (locale === "es") return es_soldil_field_v1(inputs)
	if (locale === "de") return de_soldil_field_v1(inputs)
	if (locale === "nl") return nl_soldil_field_v1(inputs)
	if (locale === "fr") return fr_soldil_field_v1(inputs)
	if (locale === "it") return it_soldil_field_v1(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_field_v1(inputs)
	if (locale === "pt") return pt_soldil_field_v1(inputs)
	if (locale === "ja") return ja_soldil_field_v1(inputs)
	return zh_soldil_field_v1(inputs)
};